module.exports = __webpack_public_path__ + "img/top2.b283e5c4.png";